export const SUPPLIER_PAGE_META = {
  dashboard: {
    title: "Dashboard",
    subtitle: "Overview of your listings, bookings, and performance.",
  },
  packages: {
    title: "Packages",
    subtitle: "Create and manage your tour packages.",
  },
  suitable: {
    title: "Suitable For",
    subtitle: "Manage suitable-for options used in your packages.",
  },
  inclusions: {
    title: "Inclusions",
    subtitle: "Manage inclusions offered with your packages.",
  },
  slots: {
    title: "Slots",
    subtitle: "Manage package availability slots.",
  },
  stopSales: {
    title: "Stop Sales",
    subtitle: "Pause sales for selected packages and dates.",
  },
  events: {
    title: "Events",
    subtitle: "Create and manage your events.",
  },
  attractions: {
    title: "Attractions",
    subtitle: "Create and manage your attractions.",
  },
  masterAttractions: {
    title: "Master Attractions",
    subtitle: "Manage attraction master data for packages.",
  },
  activities: {
    title: "Activities",
    subtitle: "Create and manage your activities.",
  },
  rentals: {
    title: "Rentals",
    subtitle: "Create and manage your rental listings.",
  },
  rentalManagement: {
    title: "Rental management",
    subtitle: "Manage currently booked rental items.",
  },
  rentalCategory: {
    title: "Rental Categories",
    subtitle: "Manage rental category master data.",
  },
  rentalSubCategory: {
    title: "Rental Sub Categories",
    subtitle: "Manage rental sub-category master data.",
  },
  hotels: {
    title: "Hotels",
    subtitle: "Manage hotel master data for your packages.",
  },
  bookings: {
    title: "Bookings",
    subtitle: "View and manage bookings across your services.",
  },
  transactions: {
    title: "Transactions",
    subtitle: "View your payment transactions.",
  },
  enquiry: {
    title: "Enquiries",
    subtitle: "Review customer enquiries for your packages.",
  },
  attractionCategory: {
    title: "Attraction Categories",
    subtitle: "Manage attraction category master data.",
  },
  profile: {
    title: "Profile",
    subtitle: "Update your account and business details.",
  },
};
